import { FC } from 'react';
import { UploadFileV2 } from 'team-hero-ui';
import { DragDropContext, Droppable, DropResult } from '@hello-pangea/dnd';

import type { IImageFileDummy } from 'interfaces/File.interface';
import type { IPicturesFieldProps } from './PicturesField.types';
import { moveItem } from 'helpers/array/arrayOperations.helper';
import {
  ImagesContainerStyled,
  UploadFileContainerStyled,
} from './PicturesField styled';
import CustomImageField from './components/CustomImageField';

const defaultArray: [] = [];

const PicturesField: FC<IPicturesFieldProps> = ({
  accept,
  value = defaultArray,
  onChange,
  maxImages,
  disabled = false,
  styleType = 'modal',
  inputRef,
  helperText,
}) => {
  const onDeleteImg = (index: number) => {
    const currentImages = [...value];
    currentImages.splice(index, 1);

    onChange(currentImages);
  };

  const onDragEnd = (dropResult: DropResult) => {
    if (
      !!dropResult.draggableId &&
      typeof dropResult.destination?.index === 'number'
    ) {
      const fromIndex = parseInt(dropResult.draggableId, 10);
      const toIndex = dropResult.destination.index;
      const currentArray = moveItem(value, fromIndex, toIndex) as File[] &
        IImageFileDummy[];

      onChange(currentArray);
    }
  };

  const onAdd = (file: File) => {
    if (maxImages && value.length === maxImages) {
      const currentValues = [file, ...value] as File[];

      onChange(currentValues.splice(maxImages - 1, 1));
    } else {
      onChange([...value, file]);
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId='droppable'
        direction='horizontal'
        isDropDisabled={disabled}
      >
        {(provided, snapshot) => (
          <ImagesContainerStyled
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {provided.placeholder}
            {value.map((item, index) => (
              <CustomImageField
                key={index}
                item={item as File & IImageFileDummy}
                index={index}
                disabled={disabled}
                isDraggingOver={snapshot.isDraggingOver}
                onDeleteImgCallback={onDeleteImg}
                styleType={styleType}
              />
            ))}
            {!snapshot.isDraggingOver &&
              !disabled &&
              !(maxImages && value.length >= maxImages) && (
                <UploadFileContainerStyled>
                  <UploadFileV2
                    styleType={styleType === 'modal' ? 'greenUpload' : 'grey'}
                    accept={accept}
                    onAdd={(file) => onAdd(file)}
                    inputRef={inputRef}
                    helperText={helperText}
                  />
                </UploadFileContainerStyled>
              )}
          </ImagesContainerStyled>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default PicturesField;
